import { HomeHeading, HomeLink } from './presentation'
import styles from './home.module.css'

const integrations = [
  {
    name: 'Slack',
    image: '/static/integrations/slack.png',
    href: 'https://docs.heyform.net/integrations/slack'
  },
  {
    name: 'Notion',
    image: '/static/integrations/notion.svg',
    href: 'https://docs.heyform.net/integrations/notion'
  },
  {
    name: 'Google Sheets',
    image: '/static/integrations/google-sheet.png',
    href: 'https://docs.heyform.net/integrations/google-sheets'
  },
  {
    name: 'Airtable',
    image: '/static/integrations/airtable.png',
    href: 'https://docs.heyform.net/integrations/airtable'
  },
  {
    name: 'HubSpot',
    image: '/static/integrations/hubspot.png',
    href: 'https://docs.heyform.net/integrations/hubspot'
  },
  {
    name: 'Zapier',
    image: '/static/integrations/zapier.png',
    href: 'https://docs.heyform.net/integrations/zapier'
  },
  {
    name: 'Stripe',
    image: '/static/integrations/stripe.png',
    href: '/integrations/'
  },
  {
    name: 'Mailchimp',
    image: '/static/integrations/mailchimp.webp',
    href: 'https://docs.heyform.net/integrations/mailchimp'
  },
  {
    name: 'Google Analytics',
    image: '/static/integrations/google-analytics.webp',
    href: 'https://docs.heyform.net/integrations/google-analytics'
  },
  {
    name: 'Webhook',
    image: '/static/integrations/webhook.png',
    href: 'https://docs.heyform.net/integrations/webhook'
  },
  {
    name: 'Email',
    image: '/static/integrations/email.webp',
    href: 'https://docs.heyform.net/integrations/email'
  },
  {
    name: 'Google Drive',
    image: '/static/integrations/google-drive.png',
    href: 'https://docs.heyform.net/integrations/google-drive'
  }
]

export function Integrations() {
  return (
    <section
      className={styles.section}
      aria-labelledby="home-integrations-title"
    >
      <div className={styles.container}>
        <HomeHeading
          id="home-integrations-title"
          title="Works with the tools you already use"
          center
        >
          Connect payments, analytics, CRM, and automation. Keep form responses
          moving into the tools your team relies on.
        </HomeHeading>
        <div className={styles.integrationGrid}>
          {integrations.map(item => (
            <a key={item.name} href={item.href} className={styles.integration}>
              <img
                src={item.image}
                alt=""
                width={44}
                height={44}
                loading="lazy"
              />
              <span>{item.name}</span>
            </a>
          ))}
        </div>
        <div className={`${styles.afterGrid} ${styles.center}`}>
          <HomeLink href="/integrations/">Explore integrations</HomeLink>
        </div>
      </div>
    </section>
  )
}
